import {useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import 'react-quill/dist/quill.snow.css';
import {getSingleInsight, updateInsight} from "../../actions/NewsPages";
import { IMAGE_URL} from "../../path";

interface FormData {
    title: string;
    subtitle: string;
    image: File | null;
    image_1: File | null;
    image_2: File | null;
    image_3: File | null;
    content: string;
    content_1?: string;
    content_2?: string;
    youtube: string;
    seo_meta_title: string;
    seo_meta_description: string;
    seo_meta_keywords: string;
    seo_meta_ogimage: File | null;
}

function EditInsight() {
    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const { id } = useParams<{id?: string }>();

    const handleQuillChange = (value: string, name: string) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    };


    const ReactQuill = require('react-quill');
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean'],
        ],
    };

    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    const [formData, setFormData] = useState<FormData>({
        title: "",
        subtitle: "",
        image: null,
        image_1: null,
        image_2: null,
        image_3: null,
        content: "",
        content_1: "",
        content_2: "",
        youtube: "",
        seo_meta_title: "",
        seo_meta_description: "",
        seo_meta_keywords: "",
        seo_meta_ogimage: null,
    });

    const [photoUrl, setPhotoUrl] = useState<string>("");
    const [socialUrl, setSocialUrl] = useState<string>("");
    const [image1Url, setImage1Url] = useState<string>("");
    const [image2Url, setImage2Url] = useState<string>("");
    const [image3Url, setImage3Url] = useState<string>("");

    useEffect(() => {
        const fetchSingleInsight = async () => {
            try {
                if (!id) return;

                const response = await getSingleInsight(Number(id));
                const data = response.data.data;


                if (data) {
                    setFormData(prev => ({
                        ...prev,
                        title: data.title,
                        subtitle: data.subtitle,
                        caption: data.caption,
                        content: data.content,
                        content_1: data.content_1,
                        content_2: data.content_2,
                        youtube: data.youtube,
                        seo_meta_title: data.seo_meta_title,
                        seo_meta_description: data.seo_meta_description,
                        seo_meta_keywords: data.seo_meta_keywords,
                    }))

                    if (data.image) {
                        setPhotoUrl(data.image);
                    }

                    if (data.seo_meta_ogimage) {
                        setSocialUrl(data.seo_meta_ogimage);
                    }

                    if (data.image_1) {
                        setImage1Url(data.image_1);
                    }

                    if (data.image_2) {
                        setImage2Url(data.image_2);
                    }

                    if (data.image_3) {
                        setImage3Url(data.image_3);
                    }
                }

            } catch (error) {
                console.error("Error fetching news post:", error);
                setErrors(["Failed to load news post."]);
            }
        }
        fetchSingleInsight();
    }, [])

    const [errors, setErrors] = useState<string[]>([]);
    const [successMessage, setSuccessMessage] = useState<string>("");

    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        const { name, value, type } = e.target;

        if (type === "file") {
            const fileInput = e.target as HTMLInputElement;
            const file = fileInput.files?.[0] || null;
            setFormData(prev => ({ ...prev, [name]: file }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setErrors([]);
        setSuccessMessage("");

        try {
            const formDataToSend = new FormData();

            // Append basic form data
            Object.keys(formData).forEach(key => {
                const value = formData[key as keyof FormData];
                if (value !== null && value !== undefined) {
                    if (value instanceof File) {
                        formDataToSend.append(key, value);
                    } else {
                        formDataToSend.append(key, value.toString());
                    }
                }
            });

            // Call the actual API method
            const response = await updateInsight(formDataToSend, Number(id));

            if (response.data?.success) {
                setSuccessMessage("News webinar created successfully!");
                navigate('/dashboard/insights/list', {state: {user}});
                // Optionally: reset form here if needed
                // setFormData(initialFormData);
            } else {
                // Handle possible failure even with 200 OK response
                setErrors([response.data?.message || "An unexpected error occurred"]);
            }

        } catch (error: any) {
            console.error("Error submitting form:", error);
            // If the server returned validation errors:
            if (error.response?.data?.errors) {
                const errorMessages = Object.values(error.response.data.errors).flat();

            } else {
                setErrors(["An error occurred while submitting the form"]);
            }
        }
    };

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <h2>Add New Insight</h2>
                <form
                    className="form-horizontal form-label-left"
                    onSubmit={handleSubmit}
                    encType="multipart/form-data"
                    style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                >
                    <div style={{display: 'flex', gap: '10px', marginBottom: '10px'}}>
                        <div style={{flex: 6, border: '0.5px solid #a5adb5', padding: '10px'}}>
                            <h3>Content</h3>
                            <div className="content-form-field" style={{ marginBottom: '10px' }}>
                                <input
                                    type="text"
                                    className="input-email"
                                    placeholder="Title"
                                    id="title"
                                    name="title"
                                    value={formData.title}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: '10px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label">Subtitle</label>
                                    <textarea
                                        value={formData.subtitle}
                                        onChange={handleInputChange}
                                        name="subtitle"
                                        className="form-control news_subtitle"
                                        // placeholder="Subtitle"
                                        required />
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '10px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label" style={{marginRight: '20px'}}>Image</label> <br/>
                                    <input
                                        type="file"
                                        id="image"
                                        className="form-control news_image"
                                        name="image"
                                        ref={fileInputRef}
                                        onChange={handleInputChange}
                                    />

                                    <br/>
                                    <img src={IMAGE_URL + photoUrl} alt="image" style={{width: '50%', height: 'auto'}}/>
                                </div>
                            </div>
                            <div style={{display: 'flex', gap: '10px', marginBottom: '10px'}}>
                                <div style={{flex: 1, border: '0.5px solid #a5adb5', padding: '10px'}}>
                                    <div className="form-group" style={{ marginBottom: '10px' }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <label className="control-label" style={{marginRight: '20px'}}>Body Image 1</label> <br/>
                                            <input
                                                type="file"
                                                id="image_1"
                                                className="form-control news_image"
                                                name="image_1"
                                                ref={fileInputRef}
                                                onChange={handleInputChange}

                                            />
                                            <img src={IMAGE_URL + image1Url} alt="image" style={{width: '50%', height: 'auto'}}/>
                                            <br/>
                                        </div>
                                    </div>
                                </div>
                                <div style={{flex: 1, border: '0.5px solid #a5adb5', padding: '10px'}}>
                                    <div className="form-group" style={{ marginBottom: '10px' }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <label className="control-label" style={{marginRight: '20px'}}>Body Image 2</label> <br/>
                                            <input
                                                type="file"
                                                id="image_2"
                                                className="form-control news_image"
                                                name="image_2"
                                                ref={fileInputRef}
                                                onChange={handleInputChange}

                                            />
                                            <img src={IMAGE_URL + image2Url} alt="image" style={{width: '50%', height: 'auto'}}/>
                                            <br/>
                                        </div>
                                    </div>
                                </div>
                                <div style={{flex: 1, border: '0.5px solid #a5adb5', padding: '10px'}}>
                                    <div className="form-group" style={{ marginBottom: '10px' }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <label className="control-label" style={{marginRight: '20px'}}>Body Image 3</label> <br/>
                                            <input
                                                type="file"
                                                id="image_3"
                                                className="form-control news_image"
                                                name="image_3"
                                                ref={fileInputRef}
                                                onChange={handleInputChange}

                                            />
                                            <img src={IMAGE_URL + image3Url} alt="image" style={{width: '50%', height: 'auto'}}/>
                                            <br/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '0' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label">Content 1 (Compulsory)</label>
                                    <ReactQuill
                                        value={formData.content}
                                        onChange={(value: string) => handleQuillChange(value, 'content')}
                                        modules={modules}
                                        theme="snow"
                                        style={{ minHeight: '200px' }}
                                        required
                                    />
                                </div>
                                <div className="form-group" style={{ marginBottom: '10px' }}>
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label className="control-label">Content 2 (optional)</label>
                                        <ReactQuill
                                            value={formData.content_1}
                                            onChange={(value: string) => handleQuillChange(value, 'content_1')}
                                            modules={modules}
                                            theme="snow"
                                            style={{ minHeight: '200px' }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group" style={{ marginBottom: '10px' }}>
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label className="control-label">Content 3 (optional)</label>
                                        <ReactQuill
                                            value={formData.content_2}
                                            onChange={(value: string) => handleQuillChange(value, 'content_2')}
                                            modules={modules}
                                            theme="snow"
                                            style={{ minHeight: '200px' }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group" style={{ marginBottom: '10px' }}>
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label className="control-label">Youtube (embed iframe)</label>
                                        <textarea
                                            value={formData.youtube}
                                            onChange={handleInputChange}
                                            name="youtube"
                                            className="form-control news_subtitle"
                                            required />
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div style={{flex: 4, border: '0.5px solid #a5adb5', padding: '10px'}}>
                            <h3>SEO</h3>
                            <div className="form-group" style={{ marginBottom: '10px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label" style={{textAlign: 'left'}}>SEO Title</label>
                                    <input
                                        type="text"
                                        className="form-control news_title"
                                        name="seo_meta_title"
                                        value={formData.seo_meta_title}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="eg. Vinimark | Title"
                                    />
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '10px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label">SEO Meta Description</label>
                                    <textarea
                                        value={formData.seo_meta_description}
                                        onChange={handleInputChange}
                                        name="seo_meta_description"
                                        className="form-control news_subtitle"
                                        placeholder="min:50; max:160 characters"
                                        required />
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '10px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <label className="control-label">SEO Meta Keywords</label>
                                    <textarea
                                        value={formData.seo_meta_keywords}
                                        onChange={handleInputChange}
                                        name="seo_meta_keywords"
                                        className="form-control news_subtitle"
                                        placeholder="seperate each keyword with a comma"
                                        required />
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '20px' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12" >
                                    <label className="control-label" style={{marginRight: '20px'}}>Social Media sharing image</label> <br/>
                                    <label className="control-label" style={{marginRight: '20px', fontSize: '12px'}}>max: 2 megabytes; dimensions: 300 x 300px</label><br/> <br/>
                                    <input
                                        type="file"
                                        id="seo_meta_ogimage"
                                        className="form-control news_image"
                                        name="seo_meta_ogimage"
                                        ref={fileInputRef}
                                        onChange={handleInputChange}
                                    />
                                    <br/>
                                    <img src={IMAGE_URL + socialUrl} alt="image" style={{width: '50%', height: 'auto'}}/>

                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: '0' }}>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <button type="submit" className="btn btn-success">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>



            </div>
        </div>
    )
}

export default EditInsight;
